import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Platform } from '@ionic/angular';

import { DomainService } from '../services/domain/domain.service';
import { StorageService } from '../services/storage/storage.service';

import { SplashScreen } from '@capacitor/splash-screen';
import { STORAGE_CONST } from '../constants/storage-constants';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Capacitor } from '@capacitor/core';
@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  constructor(
    private storage: StorageService,
    private domainSvc: DomainService,

    // private zone: NgZone,
    private plt: Platform,
    private router: Router
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const isReady = await this.plt.ready();
    if (isReady) {
      if (Capacitor.isNativePlatform()) {
        setTimeout(async () => {
          await SplashScreen.hide();
          setTimeout(async () => {
            await StatusBar.setStyle({ style: Style.Dark });
            await StatusBar.setBackgroundColor({ color: '#000000' });
          }, 500);
        }, 1000);
      }
      const firstRunIsDone = await this.storage.get(
        STORAGE_CONST.FIRST_RUN_PERMISSION
      );
      if (firstRunIsDone) {
        const params = route.queryParams;
        this.router.navigate(['/app/add-files'], {
          replaceUrl: true,
          queryParams: params?.domainname && params?.locationid ? params : {},
        });
        return true;
      }
      return true;
    }
    return false;
  }

  /**
   * Get account details
   */
  async getaccountinfo() {
    const domaininfo = await this.storage.getJson(STORAGE_CONST.DOMAIN_INFO);
    if (domaininfo) {
      const result = await this.domainSvc.domainDetails(domaininfo.domainname);
      const primaryColor = result.customizations.Hex500;
      const r = document.querySelector(':root');
      r['style'].setProperty('--ion-color-eprintprimary', '' + primaryColor);
    }
  }
}
